export default __webpack_public_path__ + "static/FTP-Fritzbox-7490de_07-5532b3a41a3ef287791ad8a9c783a4a2.webp";